import { ENDPOINTS } from '../../network/endpoints';

/**
 * LiveKit API (OpenAPI: swagger/livekit-swagger.yaml)
 * @implements {import('../../../contracts/ILivekitRepository').ILivekitRepository}
 */
export class LivekitRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async postConnectionToken(body) {
    return this.client.post(ENDPOINTS.LIVEKIT.TOKEN, body);
  }
}
